var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerSupply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_276)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 50,
    r: 50,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.9029 45.201C69.8233 45.0352 69.6992 44.8954 69.5447 44.7976C69.3902 44.6997 69.2116 44.6479 69.0294 44.648H58.9159L66.9948 27.4012C67.065 27.2517 67.0966 27.0866 67.0866 26.9213C67.0767 26.7561 67.0256 26.5961 66.938 26.4562C66.8504 26.3164 66.7293 26.2012 66.5858 26.1214C66.4424 26.0416 66.2813 25.9999 66.1176 26H50.5883C50.4011 26 50.2178 26.0547 50.0607 26.1576C49.9035 26.2605 49.7792 26.4071 49.7025 26.5799L37.085 55.0425C37.0187 55.192 36.9905 55.3559 37.0028 55.5192C37.0152 55.6825 37.0679 55.8401 37.1559 55.9776C37.244 56.1151 37.3647 56.2282 37.507 56.3064C37.6493 56.3847 37.8087 56.4256 37.9707 56.4256H47.4428L42.8459 77.809C42.799 78.026 42.8263 78.2526 42.9232 78.4519C43.0202 78.6512 43.1812 78.8113 43.3798 78.9061C43.5784 79.0009 43.803 79.0248 44.0167 78.9738C44.2305 78.9229 44.4209 78.8001 44.5567 78.6256L69.7918 46.2371C69.9045 46.0923 69.9747 45.9183 69.9943 45.7351C70.014 45.552 69.9823 45.3669 69.9029 45.201Z",
    fill: "#5f9098"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_276",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.564706 0 0 0 0 0.596078 0 0 0 1 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.564706 0 0 0 0 0.596078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_276"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_276",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerSupply);
export default __webpack_public_path__ + "static/media/powerSupply.7b5bcf57905e640acae46043a51263a8.svg";
export { ForwardRef as ReactComponent };